module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cost-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-discounts",
      "to": {
        name: 'Discounts'
      },
      "md-label": "Скидки"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-luwprices",
      "to": {
        name: 'LuwPrices'
      },
      "md-label": "ПРР"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-doom-prices",
      "to": {
        name: 'DoomPrices'
      },
      "md-label": "Обрешётка"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-forwardingprices",
      "to": {
        name: 'ForwardingPrices'
      },
      "md-label": "Экспедирование"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-services",
      "to": {
        name: 'AdditionalServices'
      },
      "md-label": "Дополнительные услуги"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-other",
      "to": {
        name: 'OtherSettings'
      },
      "md-label": "Прочие параметры"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-paymentmethods",
      "to": {
        name: 'PaymentMethods'
      },
      "md-label": "Способы оплаты"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-zones",
      "to": {
        name: 'Zones'
      },
      "md-label": "Направления"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "tab-cities",
      "to": {
        name: 'Cities'
      },
      "md-label": "Населённые пункты"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27cef4ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/menu.vue
// module id = 1078
// module chunks = 0